module.exports = ".lang-es {\n  background-color: red; }\n\n.lang-eng {\n  background-color: blue; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/form/lenguaje/lenguaje.component.scss
// module id = ./src/app/shared/components/form/lenguaje/lenguaje.component.scss
// module chunks = main